export default __webpack_public_path__ + "static/media/White-paper.cbd17b7b.png";